import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search'
})
export class SearchPipe implements PipeTransform {
  public transform(value: any[], keys: string, term: string) {
    if (term === undefined) {
      return value;
    }

    return (value || []).filter((item: any) => {
      return keys.split(',').some((key: any) => {
        const value = this.fetchFromObject(item, key);
        if (typeof value === "string") {
          return new RegExp(term, 'gi').test(value);
        } else if ((typeof value) === "number" || (typeof value) === "boolean") {
          return String(value) === term;
        } else {
          return String(value) === term;
        }
      });
    });

  }

  //TODO:featureToggle.service has similar function
  private fetchFromObject(obj: any, prop: string): any {
    //property not found
    if (typeof obj === 'undefined') return undefined;

    //index of next property split
    var _index = prop.indexOf('.')

    //property split found; recursive call
    if (_index > -1) {
      //get object at property (before split), pass on remainder
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    //no split; get property
    return obj[prop];
  }
}
